import { useNavigate } from 'react-router-dom'

import { Button } from '@/components/ui/button'

export function StigsStepSection() {
  const navigate = useNavigate()

  return (
    <div className="space-y-3">
      <div className="flex items-center justify-between">
        <h4 className="text-sm font-semibold">STIG Applicability</h4>
        <Button variant="outline" onClick={() => navigate('/softwareiq/assurance/stigs')}>
          Open STIG Review
        </Button>
      </div>
      <p className="text-sm text-muted-foreground">
        Use the STIG catalog to select applicable checklists and capture SME rationale.
      </p>
    </div>
  )
}
